import Paper from '@mui/material/Paper'
import { styled } from '@mui/material/styles'

import styles from './TempDropdown.styles'

const TempDropdown = styled(Paper)(styles.autocompletePaper)

export default TempDropdown
